import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M145-146q-33 0-56-23t-23-56v-510q0-33 23-57t56-23h461q19 0 36 9t28 24l190 255q16 20 16 47t-16 47L671-178q-11 15-28 24-17 8-36 8H145Zm0-79h462l190-255-190-255H145v510Zm326-255Z"/>',
  f: '<path d="M145-146q-33 0-56-23t-23-56v-510q0-33 23-56 23-24 56-24h461q19 0 36 9t28 24l190 255q16 20 16 47t-16 47L671-178q-11 15-28 24-17 8-36 8H145Z"/>',
};

export default data;
